import { featureOrderEpic } from '@/epics/featureOrderEpic';
import { hostInitEpic } from '@/epics/hostInitEpic';
import { hostListEpic } from '@/epics/hostListEpic';
import { hostRestEpic } from '@/epics/hostRestEpic';
import {
    addBetEpic,
    bjStandBetEpic,
    clearPendingEpic,
    initBetEpic,
    startBJBetEpic,
    undoBetEpic,
    updateConfirmedBetsEpic,
} from '@/epics/tableBetEpic';
import { updateCardOnlyEpic, updateHandsEpic } from '@/epics/updateHandsEpic';
import { combineEpics } from 'redux-observable';
import { roadmapEpic } from '../epics/roadmapEpic';
export const rootEpic = combineEpics(
    roadmapEpic,
    initBetEpic,
    addBetEpic,
    undoBetEpic,
    bjStandBetEpic,
    clearPendingEpic,
    hostListEpic,
    hostInitEpic,
    hostRestEpic,
    featureOrderEpic,
    updateHandsEpic,
    updateCardOnlyEpic,
    updateConfirmedBetsEpic,
    startBJBetEpic
);
